import * as React from "react";
import styled from "@emotion/styled";
import ErrorCard from "@/components/molecules/ErrorCard";
import breakpoint from "@/utils/breakpoint";

const Wrapper = styled.div`
  width: 100%;
  height: 100vh;
  padding: 10px;
  display: flex;
  flex-flow: column;
  justify-content: space-between;
`;

const BlankBox = styled.div`
  width: 100%;
  height: 100px;
  background: rgb(44, 132, 202);
  background: linear-gradient(145deg, rgba(44, 132, 202, 1) 0%, rgba(56, 175, 209, 1) 35%);

  ${breakpoint.lessThan("md")`
    height: 50px;
  `}
`;

const NotFound = () => (
  <Wrapper>
    <BlankBox />
    <ErrorCard
      title="お探しのページが見つかりません"
      description={
        <>
          お探しのページが見つかりませんでした。
          <br />
          URLを間違えている可能性があります。ご確認の上、再度お試しください。
        </>
      }
    />
    <BlankBox />
  </Wrapper>
);

export default NotFound;
